// extracted by mini-css-extract-plugin
export default {"btns":"PaginationBtns_btns__gDsdv","btn":"PaginationBtns_btn__8mONm"};